type DocumentShape = { isFormDataValid(): boolean };

function areDocumentsValid(value: readonly (readonly DocumentShape[])[]): boolean {
	return value.every((stage) => stage.every((document) => document.isFormDataValid()));
}

export default areDocumentsValid;
